<template>
  <div class="material-grid">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.material-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
  grid-template-rows: 1fr;
  grid-gap: $spacer-4;

  @include media-breakpoint-down(md) {
    grid-template-columns: 1fr;
  }

  @include media-breakpoint-down(sm) {
    grid-gap: $spacer-75;
  }
}
</style>
